import { Navigate } from "react-router-dom";
import useUserContext from "../../hooks/useUserContext";
import Loader from "../loader/Loader";
import React from "react";

interface ProtectedRouteProps {
    children: JSX.Element;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { user, isInitialLoadDone } = useUserContext();
    if(user?.email) return children;

    if(!isInitialLoadDone) {
        return <div className="loading-state">
            <Loader size={250} />
        </div>
    }

    return <Navigate to="/start" replace />
}

export default ProtectedRoute;